import { render, staticRenderFns } from "./FormProSetting.vue?vue&type=template&id=ba14fb4c&scoped=true"
import script from "./FormProSetting.vue?vue&type=script&lang=js"
export * from "./FormProSetting.vue?vue&type=script&lang=js"
import style0 from "./FormProSetting.vue?vue&type=style&index=0&id=ba14fb4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba14fb4c",
  null
  
)

export default component.exports